module.exports = __webpack_public_path__ + "static/media/cards.d6489497.md";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Containers/cards.md
// module id = 212
// module chunks = 0